<script>
	const Vue = require('vue/dist/vue.js');
	const Parallax = require('parallax-js');
	const getOffsetTop = require('../../common/getOffsetTop');
	const clientCase = Vue.component('client-case', {
		props: {
			caseData: {
				required: true,
				type: Object
			},
			index: {
				required: true,
				type: Number
			}
		},
		data() {
			return {
				parallaxInstance: null,
				appearanced: false,
				/*
				setted keyframe in portfolio.scss,
				needs to set into element style when animation starts
				 */ 
				animationName: 'appearance' 
			}
		},
		watch: {
			'$parent.scrollBottom'() {
				this.animateAppearance()
			}
		},
		methods: {
			animateAppearance() {
				if (this.$parent.scrollBottom > getOffsetTop(this.$el) && !this.appearanced) {
					// console.log(this.$el, this.$parent.scrollBottom, this.$el.getBoundingClientRect().top)
					this.$el.setAttribute('style', `animation-name: ${this.animationName};`);
					this.appearanced = true
				}
			}
		},
		mounted() {
			if (!this.parallaxInstance && this.$device().desktop()) {
				const stage = this.$el.querySelector(".client-case__parallax");
				this.parallaxInstance = new Parallax(stage)
			};
			this.animateAppearance();
		}
	})
	module.exports = clientCase
</script>
<template>
	<div class='client-case'>
		<div class='client-case__parallax'>
			<div class='client-case__backward'
			:style="[
				{ backgroundImage: 'url(' + caseData.bg + ')' },
				{backgroundPositionY: caseData.bgCoords ? caseData.bgCoords.y: ''},
				{backgroundPositionX: caseData.bgCoords ? caseData.bgCoords.x : ''}
			]"
			data-depth='0.07'></div>
		</div>
		<div class='client-case__forward'>
			<p class='client-case__dates client-case__dates--sm-hidden'
				v-if='caseData.dates && caseData.dates.length'>{{caseData.dates}}</p>
			<h3 class='client-case__title client-case__title--sm-hidden'>{{caseData.title}}</h3>
			<h4 class='client-case__desc client-case__desc--sm-hidden'>{{caseData.summary}}</h4>
			<a class='client-case__btn client-case__btn--sm-hidden'
				v-if='caseData.link'
				:href='caseData.link'>посмотреть кейс</a>
			<div class='client-case__logo' v-if='caseData.logo'>
				<img :src='caseData.logo' :alt='caseData.title'>
			</div>
			<ul class='client-case__service-list client-case__service-list--sm-hidden'>
				<li class='client-case__service-item'
					v-for='(item, index) in caseData.features'
					:key='index'>{{item}}</li>
			</ul>
			<div class='client-case__tablet-row'>
				<div class='client-case__company-data'>
					<p class='client-case__dates'
						v-if='caseData.dates && caseData.dates.length'>{{caseData.dates}}</p>
					<h3 class='client-case__title'>{{caseData.title}}</h3>
					<h4 class='client-case__desc'>{{caseData.summary}}</h4>
				</div>
				<div class='client-case__services'>
					<a class='client-case__btn'
						v-if='caseData.link'
						:href='caseData.link'>посмотреть кейс</a>
					<ul class='client-case__service-list'>
						<li class='client-case__service-item'
							v-for='(item, index) in caseData.features'
							:key='index'>{{item}}</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>